import React from 'react';
import PropTypes from 'prop-types';

import Icon from '@Theme/hijunior/components/Icon/Icon';
import Text from '../../components/Text/Text';

import * as styles from './Categories.module.scss';

const propTypes = {
  /**
   * Icon
   */
  icon: PropTypes.string,

  /**
   * Icon size
   */
  iconSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  }),

  /**
   * Title content
   */
  title: PropTypes.string,

  /**
   * Number of articles
   */
  description: PropTypes.string,

  /**
   * Url to category page
   */
  url: PropTypes.string
};

const CategoriesItem = ({
  icon,
  iconSize,
  title,
  description,
  url
}) => {
  const Component = url ? 'a' : 'div';

  return (
    <Component href={url} className={styles.rootItem}>
      <div className={styles.rootItemHead}>
        <Text classname={styles.rootItemTitle} as='h3' contents={title}/>
        <div className={styles.rootIconWrapper}>
          <Icon name={icon} classname={styles.rootItemIcon} size={iconSize}/>
        </div>
      </div>
      <div className={styles.rootItemTextContent}>
        <Text classname={styles.rootItemArticles} contents={description}/>
      </div>
    </Component>
  );
};

CategoriesItem.propTypes = propTypes;

export default CategoriesItem;
